import React from 'react';
import {
  Notification,
  Message
} from '../../web.common';
import { sentenceCase } from 'change-case';
import { getApiErrorMessage } from '../../common/utils';
import CreatableArea from './CreatableArea';

class CreateEntity extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false
    };

    this.save = this.save.bind(this);
  }

  async onValidationError({ validateForm }) {
    const {
      onValidationError: passedOnValidationError,
      showValidationErrors
    } = this.props;

    const validationErrors = await validateForm();
    if (showValidationErrors) {
      const fieldsWithError = Object.keys(validationErrors).map(x => sentenceCase(x)).join(', ');
      this.setState({
        apiResponse: new Message('error', `Unable to save. Check fields: ${fieldsWithError}`)
      });
    }

    if (passedOnValidationError) {
      passedOnValidationError(validationErrors);
    }
  }

  save(receivedProps) {
    this.setState({ isLoading: true }, async () => {
      const {
        language,
        createData,
        entity,
        onSaveCompleted
      } = this.props;

      let apiResponse;
      let outcome = null;

      try {
        outcome = await createData(receivedProps.values);
        apiResponse = new Message('success', `${entity} created successfully`);
      }
      catch (error) {
        console.error(`error while saving: ${error}`);
        apiResponse = getApiErrorMessage(error, language);
      }

      this.setState({
        isLoading: false,
        saveError: null,
        apiResponse
      });

      // TODO check this one
      if (receivedProps.toggleAreaEditMode) {
        receivedProps.toggleAreaEditMode();
      }

      if (onSaveCompleted) {
        onSaveCompleted(outcome);
      }
    });
  }

  render() {
    const { isLoading, apiResponse } = this.state;

    const { entity, validation, getFormData, children } = this.props;

    const formData = getFormData();

    return (
      <React.Fragment>
        <Notification newMessage={apiResponse} />

        <CreatableArea
          ariaEditorName={`${entity}-edit`}
          onSubmit={receivedProps => this.save(receivedProps)}
          isLoading={isLoading}
          savingText='text-loading-save'
          displayButtonLabels
          validationSchema={validation}
          onValidationError={formikProps => this.onValidationError(formikProps)}
          initialValues={formData}
        >
          {children(formData)}
        </CreatableArea>
      </React.Fragment>
    );
  }
}

export default CreateEntity;